<template lang="pug">
.activation
    .panel.panel-default
      .panel-heading
        .panel-title {{ title }}
      .panel-body
        form.form-horizontal(role="form")
          .form-group
            label.col-sm-6.control-label Enable
            .col-sm-6.activation-checkbox
              input(v-model="value.enabled" type="checkbox")
          .form-group
            label.col-sm-6.control-label(:title="timezone") From
            .col-sm-6
              DatePicker(v-model="value.activateDate" :timePicker="true")
          .form-group
            label.col-sm-6.control-label(:title="timezone") To
            .col-sm-6
              DatePicker(v-model="value.deactivateDate" :timePicker="true")
          .form-group
            label.col-sm-6.control-label Limit Validations
            .col-sm-1.activation-checkbox
              input(v-model="limitedValidations" type="checkbox")
            div(v-if="limitedValidations")
              .col-sm-5
                input.form-control(v-model.number="value.maxValidations" type="number")

</template>

<script>
import DatePicker from '@/components/common/Datepicker'
import Util from '@/service/Util'

export default {
  props: {
    title: {
      type: String,
      default: 'Activation'
    },
    value: {
      type: Object
    }
  },
  data: () => ({
    limitedValidations: false
  }),
  methods: {
    activate() {
      this.$emit('activate', this.value)
    }
  },
  watch: {
    value: {
      handler() {
        if (this.value && this.value.maxValidations && this.value.maxValidations !== null) {
          this.limitedValidations = true
        }
      },
      deep: true
    },
    limitedValidations() {
      if (this.limitedValidations === false) {
        this.value.maxValidations = null
      }
    }
  },
  computed: {
    timezone() {
      return Util.timezone()
    }
  },
  components: {
    DatePicker
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/ActivateForValidation.vue